// shared/empty-state/empty-state.component.ts
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  template: `
    <div class="flex flex-col items-center justify-center py-16 text-center">
      <div class="w-24 h-24 rounded-full bg-surface-100 dark:bg-surface-800 flex items-center justify-center mb-4">
        <i class="pi {{ icon }} text-4xl text-surface-400 dark:text-surface-500"></i>
      </div>
      <h3 class="text-xl font-semibold text-surface-900 dark:text-zinc-100 mb-2">{{ title }}</h3>
      <p class="text-surface-600 dark:text-surface-400 max-w-md mb-6">{{ message }}</p>
      <div class="flex gap-3">
        @if (showClearFilters && clearFilters) {
          <p-button
            label="Clear Filters"
            icon="pi pi-times"
            severity="secondary"
            size="small"
            (onClick)="clearFilters.emit()"
          ></p-button>
        }
        @if (showAction) {
          <p-button
            [label]="actionLabel"
            [icon]="actionIcon"
            severity="primary"
            [outlined]="actionOutlined"
            size="small"
            (onClick)="action.emit()"
          ></p-button>
        }
      </div>
    </div>
  `
})
export class EmptyStateComponent {
  @Input() icon: string = 'pi-users';
  @Input() title: string = 'No items found';
  @Input() message: string = 'No items found';
  @Input() showAction: boolean = false;
  @Input() actionLabel: string = 'Create New';
  @Input() actionIcon: string = 'pi-plus';
  @Input() actionOutlined: boolean = false;
  @Input() showClearFilters: boolean = false;
  
  @Output() action = new EventEmitter<void>();
  @Output() clearFilters = new EventEmitter<void>();
}